import ObjectSelectorForm from 'scoreboard/components/object-selector-form'
import i18n from 'scoreboard/components/i18n'
import appDisplay from 'scoreboard/components/app-display'
import { ALL_INITIATIVES } from 'scoreboard/initiatives/initiatives-gardener'

/**
 * Creates a bootslide menu item for setting an initiative chart or gantt chart
 * widget's data source (#52717 #57570).
 *
 * @param {WidgetModel} model
 * @param {Object} [options]
 * @param {boolean} [options.allowAll = false] - if true, the "All Initiatives"
 * item will be displayed in the initiatives gardener
 */
function createInitDataSourceOption(model, options = {}) {
	return {
		type: 'dialog',
		label: 'report.designer.setDataSource',
		target: e => {
			e.preventDefault()
			e.stopPropagation()

			let objectSelectorForm =
				createObjectSelectorForm(model, options)
			appDisplay.dialog(objectSelectorForm)
		}
	}
}
/**
 * Creates the ObjectSelectorForm with the given options and sets up event handlers.
 * @param {WidgetModel} model
 * @param {Object} [options]
 * @param {boolean} [options.allowAll = false] - if true, the "All Initiatives"
 * will be displayed in the initiatives gardener
 * @returns {ObjectSelectorForm}
 */
function createObjectSelectorForm(model, options) {
	let objectSelectorForm = new ObjectSelectorForm({
		title: i18n.get('report.designer.setDataSource'),
		section: 'initiatives',
		// #58045 - if allowAll is true, then "All Initiatives" will be
		// displayed in the initiatives gardener
		allowAll: options?.allowAll,
		// #59031 - display project selector (to match the behavior when adding
		// an initiative widget to a dashboard)
		showProjectSelector: true
	})

	objectSelectorForm.on('select', (initiative, organization) => {
		updateModelWithSelection(model, initiative, organization)
		objectSelectorForm.trigger('done')
	})

	return objectSelectorForm
}

/**
 * Updates the model's properties to reflect the selected initiative
 *
 * @param {WidgetModel} model
 * @param {Object} initiative
 * @param {Object} organization
 */
function updateModelWithSelection(model, initiative, organization) {
	// #58284 - handle selection of the "All Initiatives" item
	// (this is similar to the way initiative-timeline-widget-add-menu.js
	// handles this case)
	let allInits = initiative?.id == ALL_INITIATIVES
	let initiativeId = allInits ? null : initiative?.id
	let organizationId = allInits ? organization?.id : null
	let label = allInits ? organization?.label : initiative?.label

	// #58397 - set all three properties at once so we are only triggering the
	// rendering of the timeline once (see widget-view.js initialize method
	// for the the event listener for properties changes)
	model.properties.set({ initiativeId, organizationId, label })
}

export default createInitDataSourceOption
export { updateModelWithSelection }
createInitDataSourceOption.__filename__ = 'dashboards/widgets/create-init-data-source-option.js'
